import { useQuery, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from '@/lib/react-query';
import { DashboardRequest } from '@/models';
import { ReportsControllerGetRequestReportV1Params, getSMPBackendAPIAdmin } from '@/proxy';
import { toDashboardRequest } from '@/services';

function getDashboardRequests(params: ReportsControllerGetRequestReportV1Params) {
  return getSMPBackendAPIAdmin().reportsControllerGetRequestReportV1(params);
}

export function useDashboardRequests(params: ReportsControllerGetRequestReportV1Params) {
  const queryClient = useQueryClient();

  return useQuery({
    queryKey: queryKeys.dashboard.requests(params),
    queryFn: () => getDashboardRequests(params),
    select: (data) => toDashboardRequest(data),
    staleTime: 86400000,
    initialData: () =>
      queryClient.getQueryData<DashboardRequest>(queryKeys.dashboard.requests(params)),
    initialDataUpdatedAt: () =>
      queryClient.getQueryState(queryKeys.dashboard.requests(params))?.dataUpdatedAt,
  });
}
